export default __webpack_public_path__ + "static/media/icon_quizninja.9c74e224.png";